import { Database, IAsset, withLogs } from '@core';
import { SupabaseClient } from '@supabase/supabase-js';

export const fetchSwingImages = withLogs(
    async (supabaseClient: SupabaseClient<Database>, swingUUID: string): Promise<IAsset[]> => {
        const { data, error } = await supabaseClient.functions.invoke<{ images: IAsset[] }>(
            `swing-images?uuid=${swingUUID}`,
            {
                method: 'GET',
            },
        );

        if (error) {
            throw new Error(error.message || 'Failed to fetch swing videos');
        }

        if (!data) {
            throw new Error('No videos found');
        }

        return data.images;
    },
    'fetchSwingImages',
);
